<template>
  <div id="top">
    <headNav :gray="gray"></headNav>
    <!--container-->
    <div class="innerWrapper">
      <h1>Affliated companies</h1>
      <h2>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat.
      </h2>
      <h3>Removalists</h3>
      <ul class="clear">
        <li>
          <div class="img a"></div>
        </li>
        <li>
          <div class="img b"></div>
        </li>
        <li>
          <div class="img c"></div>
        </li>
        <li>
          <div class="img d"></div>
        </li>
        <li>
          <div class="img e"></div>
        </li>
      </ul>
      <h3>Electricity providers</h3>
      <ul class="clear">
        <li>
          <div class="img f"></div>
        </li>
        <li>
          <div class="img g"></div>
        </li>
        <li>
          <div class="img h"></div>
        </li>
        <li>
          <div class="img i"></div>
        </li>
      </ul>
      <h3>Gas providers</h3>
      <ul class="clear">
        <li>
          <div class="img f"></div>
        </li>
        <li>
          <div class="img g"></div>
        </li>
        <li>
          <div class="img h"></div>
        </li>
        <li>
          <div class="img i"></div>
        </li>
      </ul>
    </div>
    <!--footer -->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";

export default {
  data() {
    return {
      gray: true
    };
  },
  components: {
    headNav,
    footNav
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  }
};
</script>

<style lang="scss" scoped>
.innerWrapper {
  width: 100%;
  padding: 1.04rem 0.24rem 0 0.24rem;
  box-sizing: border-box;
  margin: 0 auto;

  h1 {
    font-size: 0.56rem;
    line-height: 0.68rem;
    color: #2a2929;
    margin-bottom: 0.32rem;
    font-family: ProximaNova-Semibold;
    padding-top: 0.48rem;
  }

  h2 {
    font-size: 0.28rem;
    margin-bottom: 0.8rem;
    line-height: 0.42rem;
    color: #3f3f46;
    word-break: break-word;
  }

  h3 {
    font-size: 0.48rem;
    color: #333333;
    line-height: 0.58rem;
    position: relative;
    margin-bottom: 0.9rem;
  }

  h3:after {
    content: "";
    width: 1.16rem;
    height: 0.06rem;
    display: block;
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    background: #ffef00;
  }

  ul {
    margin-bottom: 0.7rem;

    li {
      width: 50%;
      height: 2.52rem;
      float: left;
      box-sizing: border-box;
      position: relative;
      margin-bottom: 0.26rem;

      .img {
        width: 100%;
        height: 2.46rem;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        background-color: rgba(255, 255, 255, 1);
        border-radius: 0.06rem;
      }

      .a {
        background-image: url("../../assets/p1.png");
      }

      .b {
        background-image: url("../../assets/p2.png");
      }

      .c {
        background-image: url("../../assets/p3.png");
      }

      .d {
        background-image: url("../../assets/p4.png");
      }

      .e {
        background-image: url("../../assets/p5.png");
      }

      .f {
        background-image: url("../../assets/p6.png");
      }

      .g {
        background-image: url("../../assets/p7.png");
      }

      .h {
        background-image: url("../../assets/p8.png");
      }

      .i {
        background-image: url("../../assets/p9.png");
      }
    }

    li:nth-child(1n) {
      padding-right: 0.13rem;
    }

    li:nth-child(2n) {
      padding-left: 0.13rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/more/affiliate.vue